class TeamLocation {
  constructor(locations, locationId) {
    this.locations = locations;
    this.id = String(locationId);
  }

  get name() {
    return this.attributes ? this.attributes.name : this.id;
  }

  get attributes() {
    return this.locations.find(location => String(location.id) === this.id);
  }
}

export default TeamLocation;



// WEBPACK FOOTER //
// ./src/utils/TeamLocation.js